import React, {useEffect, useRef, useState} from 'react';
import {Link, useHistory} from "react-router-dom";
import {customStyles, STATUS} from "../../utils/constants";
import moment from "moment";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import {toast} from "react-toastify";
import swal from "sweetalert";
import {Button, Col, Dropdown, DropdownButton, Form, FormControl, InputGroup, Row} from "react-bootstrap";
import {AddIconOutline, MenuDots, SearchIcon} from "../../components/SvgIcons";
import DataTable from "react-data-table-component";
import BarLoader from "react-spinners/BarLoader";
import {DeleteReport, GetReport} from "../../services/report.service";
import {DeleteOrder} from "../../services/order.service";

function Reports(props) {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [rows, setRows] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const typingTimeoutRef = useRef(null);






    useEffect(() => {
        const fetchData = async () => {
            await getReport();
        };
        fetchData();
    }, [keyword, page, perPage,status])



    const getReport = async () => {
        setLoading(true)
        await GetReport(keyword, page, perPage,1,status).then((result) => {
            if (result?.status) {
                if (result?.data?.data) {
                    const rowData = [];
                    const startIndex = (page - 1) * perPage;
                    setPage(result?.data?.pagination?.currentPage)
                    setTotalRows(result.data.pagination.total);
                    result.data?.data.map((dt, index) => {
                        rowData.push({
                            serialNumber: startIndex + index + 1,
                            id:dt._id || '-',
                            userName: dt.user?.fullName || '-',
                            email: dt.user?.email || '-',
                            recordName: dt.record?.name || '-',
                            // module: dt?.module || '-',
                            reason: dt.reason || '-',
                            created_at: moment(dt.createdAt).fromNow(),
                            updated_at: (dt?.updatedAt ? moment(dt?.createdAt).fromNow() : '-')

                        });

                    })
                    setRows(rowData);
                    setLoading(false)
                }
            } else {
                setLoading(false)
                setRows([]);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else if(error.response.status == 404) {
                setRows([]);
            }else {
                return toast.error(error.response.data.message);
            }
        })
    }

    const onReportDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this report?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willShip) => {

            if (willShip) {
                await DeleteReport(id).then((result) => {
                    if (result.status) {
                        swal(result.message, {
                            icon: "success",
                        });
                        getReport();
                    } else {
                        toast.error(result.message);
                    }
                }).catch((error) => {
                    if (error.response.status == 401) {
                        EmptyLocalStorage()
                        history.push('/');
                    } else {
                        return toast.error(error.response.data.message);
                    }
                })
            }
        });
    }

    const onView = (data) => {
        history.push(`/reports/view-report/` + data.id, {
            data: data
        });
    }

    const userActions = (data) => {
        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots />}>
                <Dropdown.Item as="button" onClick={() => onView(data)}>View</Dropdown.Item>
                {/* <Dropdown.Item as="button" onClick={() => onReportDelete(data.id)}>Delete</Dropdown.Item> */}
            </DropdownButton>
        )
    }

    const columns = [
        {
            id: 'id',
            name: 'S.NO',
            sortable: false,
            maxWidth:'60px',
            center: true,
            selector: rowData => rowData.serialNumber,
        },
        {
            id: 'user',
            name: 'Reporting User Name',
            center: false,
            minWidth: '200px',
            maxWidth: '340px',
            sortable: true,
            selector: rowData => rowData.userName,
        },
        {
            id: 'email',
            name: 'Reporting User Email',
            minWidth:'200px',
            maxWidth:'350px',
            // grow: false,
            center: false,
            sortable: true,
            selector: rowData => rowData.email,
        },
        {
            id: 'recordName',
            name: 'Record Name',
            grow: false,
            center: false,
            selector: rowData => rowData.recordName,
        },
        {
            id: 'reason',
            name: 'Reason',
            minWidth:'200px',
            maxWidth:'350px',
            grow: true,
            center: false,
            selector: rowData => rowData.reason,
        },
        {
            id: 'created_at',
            name: 'Created At',
            grow: false,
            center: true,
            selector: rowData => rowData.created_at,
        },
        // {
        //     id: 'updated_at',
        //     name: 'Updated At',
        //     grow: false,
        //     center: true,
        //     selector: rowData => rowData.updated_at,
        // },
        // {
        //     id: 'action',
        //     name: 'Action',
        //     cell: rowData => userActions(rowData)
        // },
    ];

    const filterStatus = async (value) => {
        setStatus(value)
    }

    const handleKeyUp = (e) => {
        clearTimeout(typingTimeoutRef.current);

        const value = e.target.value;
        if (value.length > 2) {
            typingTimeoutRef.current = setTimeout(() => {
                setKeyword(value);
            }, 500); // Set keyword after 500 milliseconds of inactivity
        } else {
            setKeyword(null);
        }
    };

    return (
        <div className={"servicePage"}>
            {/*<h1 className="page-heading">Users ({totalRows})</h1>*/}
            <h1 className="page-heading">Reports</h1>
            <hr />
            <div className={"customOrderFilters"}>
                <Row>
                    {/* <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                        <InputGroup className="mb-3 search-group">
                            <InputGroup.Text id="basic-addon1"><SearchIcon /></InputGroup.Text>
                            <FormControl
                                placeholder="Search by module"
                                aria-label="Search"
                                aria-describedby="Search"
                                maxLength={"255"}
                                onKeyUp={handleKeyUp}
                            />
                        </InputGroup>
                    </Col> */}
                    <Col xs={12} sm={12} md={{ span: 2, offset: 2 }} lg={{ span: 2, offset: 2 }} xl={{ span: 2, offset: 2 }}>

                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3} xl={3}>

                    </Col>
                </Row>
                <Row>
                    <Col  xs={12} sm={6} md={4} lg={3} xl={3}>

                    </Col>
                    <Col xs={12} sm={6} md={{ span: 3, offset: 5 }} lg={{ span: 3, offset: 6}} xl={{ span: 2, offset: 7 }}>

                    </Col>
                </Row>
            </div>
            <div className="theme-dataGrid products-dataGrid">
                <DataTable
                    columns={columns}
                    data={rows}
                    // actions={actionsMemo}
                    // data={data}
                    progressPending={loading}
                    customStyles={customStyles}
                    selectableRows={false}
                    striped
                    persistTableHead
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    onChangePage={(page) => {
                        setPage(page);


                    }}
                    onChangeRowsPerPage={(currentRowsPerPage) => {
                        setPerPage(currentRowsPerPage)
                    }}
                    progressComponent={<BarLoader color={'#41D2D2'} loading={loading} css={'marginTop: 10px'}
                                                  height={'4'} width={'100%'} />}
                />
            </div>
        </div>
    );
}

export default Reports;